import path from "path";
import DomUtil from '../_util/DomUtil';
import AjaxFormData from "../_lib/util/AjaxFormData";

export class Api {
    routes: Routes;
    ajaxFormData: AjaxFormData;

    constructor() {
        this.routes = new Routes();
        this.ajaxFormData = new AjaxFormData();
    }

    public _get<T>(url: string, params: {} = {}): Promise<FetchResponse<T>> {
        const urlParams = new URLSearchParams(params).toString();
        return fetch(`${url}?${urlParams}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                [DomUtil.getMeta('_csrf_header')]: DomUtil.getMeta('_csrf')
            }
        }).then(this._buildResponse);
    }

    public _post<T>(url: string, data: {} = {}): Promise<FetchResponse<T>> {
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [DomUtil.getMeta('_csrf_header')]: DomUtil.getMeta('_csrf')
            },
            body: JSON.stringify(data)
        }).then(this._buildResponse);
    }

    public _postFormData<T>(url: string, formData: FormData): Promise<FetchResponse<T>> {
        return fetch(url + '?_csrf=' + DomUtil.getMeta('_csrf'), {
            method: 'POST',
            body: formData,
        }).then(this._buildResponse);
    }

    private _buildResponse(res: Response) {
        const {ok, status, statusText} = res;
        return res.text().then(body => {
            let data: any;

            try {
                data = body ? JSON.parse(body) : undefined;
            } catch (error) {
                data = {
                    message: ok
                        ? 'O servidor retornou uma resposta inválida.'
                        : 'Não foi possível concluir a solicitação. Tente novamente.'
                };
            }

            return ({ok, status, data, statusText});
        });

    }
}

export interface FetchResponse<T> {
    ok: boolean;
    status: number;
    statusText: string;
    data?: T;
}

export class Routes {
    ROOT: string;
    STATIC: string;
    IMG: string;
    FONTS: string;

    constructor() {
        this.ROOT = DomUtil.getMeta('root');
        this.STATIC = `${this.ROOT}/static`;
        this.IMG = `${this.STATIC}/img`;
        this.FONTS = `${this.STATIC}/fonts`;
    }

    get(route: string) {
        return `${this.ROOT}${route}`;
    }

    api(route: string) {
        return `${this.ROOT}/api${route}`;
    }

    img(route: string) {
        return `${this.IMG}/${path.basename(route)}`;
    }

    font(route: string) {
        return `${this.FONTS}/${path.basename(route)}`;
    }
}

export class Http {
    static _status = (code: number | boolean) => (status: number = 0): number | boolean => status ? code === status : code;
    static isOk = Http._status(200);
    static isCreated = Http._status(201);
    static isFound = Http._status(302);
    static isBadRequest = Http._status(400);
    static isUnauthorized = Http._status(401);
    static isNotFound = Http._status(404);
    static isNotAcceptable = Http._status(406);

    static reload() {
        location.reload();
    }

    static redirectTo(path: string = '') {
        window.location.replace(path);
    }

    static allIs(statuses: Array<number>, status: number | boolean) {
        return statuses.every(i => this._status(status)(i));
    }
}
